export enum OrderTypeEnum {
  STANDARD = 'STANDARD',
  SPECIALIZED = 'SPECIALIZED',
  ASSET = 'ASSET',
  ALL = 'ALL'
}
